import { DateTime } from "luxon";
import { UpdatePriceUsdCompare } from "@features/compare/UpdatePriceUsdCompare";
import { CompareDataGrid } from "@entities/compare/ui/CompareDataGrid";
import { Spec } from "@entities/compare/ui/CompareDataGrid/types";
import Car from "@shared/lib/interfaces/car.interface";
import { Accordion } from "@shared/ui/Accordion";
import { sectionsSpecs } from "./config";
import { CompareSpecsProps } from "./types";

export const CompareSpecs = ({
    visibleOffers,
    showOnlyDifferences,
    compareId
}: CompareSpecsProps) => {
    const filterDifferences = (offers: Car[], specs: Spec[]) => {
        return showOnlyDifferences
            ? specs.filter((spec) => new Set(offers.map((offer) => offer[spec.key])).size !== 1)
            : specs;
    };

    const isPriceUpdatedToday = (offers: Car[]) => {
        const today = DateTime.now().toISODate();
        return offers.every((offer) => {
            return offer.updatedAt
                ? DateTime.fromISO(offer.updatedAt).toISODate() === today
                : false;
        });
    };

    return (
        <>
            {sectionsSpecs.map(({ title, specs }) => {
                const filteredSpecs = filterDifferences(visibleOffers, specs);
                const shouldShowUpdatePriceUsd =
                    title === "Стоимость" && !isPriceUpdatedToday(visibleOffers);
                const updatePriceUsdAction = shouldShowUpdatePriceUsd ? (
                    <UpdatePriceUsdCompare visible={true} compareId={compareId} />
                ) : null;
                return (
                    filteredSpecs.length > 0 && (
                        <Accordion
                            key={title}
                            title={title}
                            inner={<CompareDataGrid offers={visibleOffers} specs={filteredSpecs} />}
                            action={updatePriceUsdAction}
                        />
                    )
                );
            })}
        </>
    );
};